import { useState } from "react";
import { Button, Divider, Expandable, Stack, TextField } from "components";
import { useDoctorsSearch, useScrollToDoctors } from "hooks";
import { DoctorsFilters } from "features/doctors/DoctorsFilters";
import Doctors from "features/doctors/Doctors";

interface DoctorPickerProps {
  link: string;
}

const DoctorPicker: React.FC<DoctorPickerProps> = ({ link }) => {
  const {
    search,
    filter,
    isPremium,
    page,
    onSearchChange,
    onFilterChange,
    onPremiumChange,
    onPageChange,
    onReset,
  } = useDoctorsSearch();
  const [show, toggle] = useState(Boolean(filter || isPremium));
  const ref = useScrollToDoctors(page, show);

  return (
    <Stack direction="column" gap={2}>
      <div ref={ref} style={{ marginTop: "-16px" }} />
      <Stack direction="column" gap={2}>
        <Stack>
          <TextField
            iconStart="search"
            placeholder="Search"
            value={search}
            onChange={(e) => onSearchChange(e.target.value)}
            style={{ flex: 1 }}
          />
          <Button
            iconStart="filter_list"
            onClick={() => toggle(!show)}
            active={Boolean(show || filter || isPremium)}
          >
            Filters
          </Button>
        </Stack>
        <Expandable expanded={show}>
          <Stack direction="column">
            <DoctorsFilters
              active={filter}
              isPremium={isPremium}
              onChange={onFilterChange}
              onPremiumChange={onPremiumChange}
              onReset={onReset}
            />
            <Divider />
          </Stack>
        </Expandable>
      </Stack>
      <Doctors
        link={link}
        search={search}
        page={page}
        filter={filter}
        isPremium={isPremium}
        onPageChange={onPageChange}
      />
    </Stack>
  );
};

export { DoctorPicker };
